import {visitaOfflineContextScope} from './visitaOfflineContext.js';
import {contextFileDependencies} from './visitasFormPreparation.js';

// La apertura usa el mismo proveedor de copias para visitas editables y cerradas.
// El nombre se conserva por compatibilidad: no sincroniza ni retira intenciones.
export async function prepareClosedVisitaFiles({result, source, user, canPrepare = async () => false, prepareFiles, isCurrent = () => true}) {
    const scope = visitaOfflineContextScope(user), visit = result?.context?.visita;
    if (result?.source !== 'server' || result.storageError || result.reason
        || !['pendiente', 'iniciada', 'finalizada', 'revisada', 'aprobada'].includes(visit?.estado)
        || !scope || source?.kind !== 'context' || source.scope !== scope
        || source.userId !== Number(user.id) || source.empresaId !== Number(user.empresa_id)
        || source.visitaId !== Number(visit.id) || source.context?.visita?.estado !== visit.estado
        || !isCurrent()) return {attempted: false, reason: 'context_unavailable'};
    const dependencies = contextFileDependencies(source.context).filter(item => ['photo', 'document'].includes(item.kind));
    try {
        if (!await canPrepare() || !isCurrent()) return {attempted: false, reason: 'pending_work'};
        if (!dependencies.length) return {attempted: true, complete: true, total: 0, ready: 0};
        const prepared = await prepareFiles(source, dependencies);
        const exact = Array.isArray(prepared) && prepared.length === dependencies.length
            && dependencies.every(item => prepared.filter(row => row.id === item.id && row.kind === item.kind).length === 1);
        const ready = exact ? prepared.filter(item => item.status === 'ready').length : 0;
        return {attempted: true, complete: isCurrent() && exact && ready === dependencies.length,
            total: dependencies.length, ready};
    } catch {
        return {attempted: true, complete: false, total: dependencies.length, ready: 0};
    }
}
